export const RoundingEntities = {
	RATE: {name: 'RATE', decimals: 4},
};

const isRoundingEntity = (entityType: string): entityType is keyof typeof RoundingEntities => entityType in RoundingEntities;

export default class RoundingUtility {
	static roundToNDecimals(value: number, decimalAmount: number): number {
		return Math.round((value + Number.EPSILON) * Math.pow(10, decimalAmount)) / Math.pow(10, decimalAmount);
	}

	static roundBasedOnEntityType(value: number, entityType: string): number {
		const decimalAmount = isRoundingEntity(entityType) ? RoundingEntities[entityType].decimals : 2;

		return this.roundToNDecimals(value, decimalAmount);
	}
}

/**
 * True when a rate has more decimal places than rate fields display, i.e. the field shows a rounded value.
 * Differences within floating-point error of the rate are not counted.
 */
export const isRateRoundedForDisplay = (rate: number | null | undefined): boolean => {
	if (rate == null) {
		return false;
	}
	const displayed = RoundingUtility.roundToNDecimals(rate, RoundingEntities.RATE.decimals);
	return Math.abs(displayed - rate) > Number.EPSILON * Math.max(1, Math.abs(rate));
};
